module.exports = __webpack_public_path__ + "static/media/bancoitauuruguay.8bd554b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bancoitauuruguay.jpg
// module id = 489
// module chunks = 0 1 2